<template>
  <v-container ref="target">
    <SectionTitle>
      Recursos que colocam você na frente da concorrência:
    </SectionTitle>

    <v-row class="mt-8">
      <v-col
        v-for="(feature, index) in features"
        :key="index"
        cols="6"
        md="4"
        class="animated"
        :class="{ visible: showAll }"
        :style="{ animationDelay: `${index * 80}ms` }"
      >
        <div class="resource-card">
          <div class="resource-icon-wrap">
            <img
              :alt="feature.title"
              :src="require(`@/assets/images/icons/${feature.icon}`)"
              class="resource-icon"
              loading="lazy"
            />
          </div>
          <h3 class="resource-title">{{ feature.title }}</h3>
          <p class="resource-desc">{{ feature.description }}</p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import SectionTitle from "@/components/SectionTitle.vue";

  export default {
    name: "ResourcesSection",

    components: {
      SectionTitle,
    },

    data: () => ({
      showAll: false,
      features: [
        {
          title: "Pedidos por QR Code",
          description: "Autonomia para seu cliente fazer o pedido na mesa",
          icon: "qr-code.svg",
        },
        {
          title: "Impressão Automática",
          description: "Seu maior aliado no horário de pico",
          icon: "invoice.svg",
        },
        {
          title: "Robô de Atendimento",
          description: "Responde mais de 20 clientes ao mesmo tempo, envia o cardápio e avisa sobre o status do pedido",
          icon: "robot.svg",
        },
        {
          title: "Emissão de Nota Fiscal",
          description: "Emissão de NFC-e com apenas um clique",
          icon: "nota-fiscal.svg",
        },
        {
          title: "PDV e App do Garçom",
          description: "Praticidade no atendimento de mesa, sincronizado em todos os dispositivos",
          icon: "mobile.svg",
        },
        {
          title: "Venda Complementar",
          description: "Aumente o lucro oferecendo produtos complementares aos seus clientes",
          icon: "money.svg",
        },
        {
          title: "Pix Automatizado",
          description: "Evite golpes no pix — aprovação somente após confirmação do pagamento",
          icon: "pix.svg",
        },
        {
          title: "Cupons de Desconto",
          description: "Promova as vendas oferecendo descontos ou taxa de entrega grátis",
          icon: "coupon.svg",
        },
        {
          title: "Controle de Estoque",
          description: "Produtos pausados automaticamente quando o estoque acabar",
          icon: "engine.svg",
        },
        {
          title: "Relatórios Completos",
          description: "Saiba exatamente quanto você vendeu em cada mês",
          icon: "uil-file-graph.svg",
        },
        {
          title: "Controle de Caixa",
          description: "Segurança e controle de todas as movimentações financeiras",
          icon: "moedas.svg",
        },
        {
          title: "Agendamento de Pedidos",
          description: "Venda 24 horas por dia com o agendamento de pedidos",
          icon: "calendar.svg",
        },
      ],
    }),

    mounted() {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          this.showAll = true;
          observer.disconnect();
        }
      }, { threshold: 0.1 });

      observer.observe(this.$refs.target);
    },
  };
</script>

<style scoped lang="scss">
  /* Card */
  .resource-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 28px 16px 24px;
    height: 100%;
    border-radius: 16px;
    background: var(--card-bg);
    border: 1px solid var(--card-border);
    cursor: default;
    transition: transform 0.28s ease, border-color 0.28s ease, box-shadow 0.28s ease;

    &:hover {
      transform: translateY(-6px);
      border-color: rgba(229, 9, 20, 0.45);
      box-shadow: 0 10px 28px rgba(229, 9, 20, 0.12);
    }

    @media (max-width: 600px) {
      padding: 20px 12px 18px;
    }
  }

  /* Ícone */
  .resource-icon-wrap {
    width: 58px;
    height: 58px;
    border-radius: 14px;
    background: rgba(229, 9, 20, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
    flex-shrink: 0;
  }

  .resource-icon {
    width: 28px;
    height: 28px;
  }

  /* Textos */
  .resource-title {
    font-size: 15px;
    font-weight: 600;
    line-height: 1.35;
    margin: 0 0 8px;

    @media (max-width: 600px) {
      font-size: 13px;
    }
  }

  .resource-desc {
    font-size: 13px;
    color: var(--text-muted);
    line-height: 1.55;
    margin: 0;

    @media (max-width: 600px) {
      font-size: 12px;
    }
  }

  /* Animação de entrada por scroll */
  .animated {
    opacity: 0;
    transform: translateY(28px);
    transition: opacity 0.45s ease, transform 0.45s ease;
  }

  .animated.visible {
    opacity: 1;
    transform: translateY(0);
  }
</style>
